import React from 'react';
import styled from 'styled-components';
import ArticleCard from 'app/components/blog/ArticleCard';
import { media } from 'theme';

const Container = styled.div`
  max-width: 100%;
`;

const ListContainer = styled.div`
  position: relative;

  ${media.smallAndDown`
    padding-left: 16px;
  `}
  ul {
    display: flex;
    width: 100%;
    padding-top: 5px;
    padding-bottom: 5px;
    transition: margin-left 0.4s ease-in-out;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    > li {
      margin-bottom: 16px;
    }
    ${media.smallAndDown`
      flex-wrap: nowrap;
      overflow-x: scroll;
      overflow-y: hidden;
      > li {
        margin-right: 16px;
      }
    `}

    > div:last-of-type {
      margin-right: 0;
    }
  }
`;

const List = styled.ul`
  ${media.smallAndDown`
    > li:last-child {
      padding-right: 16px;
    }
  `}
`;

const RelatedArticleSection = ({ articles }) => {
  let displayArticles;
  if (articles.length % 2 === 0 || articles.length === 1) {
    displayArticles = articles;
  } else {
    displayArticles = articles.slice(0, articles.length - 2);
  }
  return (
    <Container>
      <ListContainer>
        <List>
          {articles &&
            displayArticles.map((article, i) => (
              <li key={i}>
                <ArticleCard theme="large" {...article} />
              </li>
            ))}
        </List>
      </ListContainer>
    </Container>
  );
};

export default RelatedArticleSection;
